/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    core: {
        color: {
            brand: {
                primary: {
                    diligentRed: {
                        value: "#ee312e",
                        type: "color",
                    },
                    red2: {
                        value: "#d3222a",
                        type: "color",
                    },
                    red3: {
                        value: "#af292e",
                        type: "color",
                    },
                    red4: {
                        value: "#921a1d",
                        type: "color",
                    },
                    red5: {
                        value: "#5f091d",
                        type: "color",
                    },
                },
                secondary: {
                    blue1: {
                        value: "#00d3f3",
                        type: "color",
                    },
                    blue2: {
                        value: "#0086fa",
                        type: "color",
                    },
                    blue3: {
                        value: "#0b4cce",
                        type: "color",
                    },
                    purple1: {
                        value: "#c247fa",
                        type: "color",
                    },
                    purple2: {
                        value: "#8b4bfa",
                        type: "color",
                    },
                    purple3: {
                        value: "#642fcf",
                        type: "color",
                    },
                },
                neutral: {
                    gray1: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    gray2: {
                        value: "#dadada",
                        type: "color",
                    },
                    gray3: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                    gray4: {
                        value: "#6f7377",
                        type: "color",
                    },
                    gray5: {
                        value: "#282e37",
                        type: "color",
                    },
                },
            },
            gray: {
                "0": {
                    value: "#ffffff",
                    type: "color",
                },
                "100": {
                    value: "#f3f3f3",
                    type: "color",
                },
                "200": {
                    value: "#e6e6e6",
                    type: "color",
                },
                "300": {
                    value: "#dadada",
                    type: "color",
                },
                "400": {
                    value: "#b6b8b9",
                    type: "color",
                },
                "500": {
                    value: "#a0a2a5",
                    type: "color",
                },
                "600": {
                    value: "#8c8e92",
                    type: "color",
                },
                "700": {
                    value: "#6f7377",
                    type: "color",
                },
                "800": {
                    value: "#464e53",
                    type: "color",
                },
                "900": {
                    value: "#282e37",
                    type: "color",
                },
                "950": {
                    value: "#121a26",
                    type: "color",
                },
                "1000": {
                    value: "#000000",
                    type: "color",
                },
            },
            green: {
                "0": {
                    value: "#000000",
                    type: "color",
                },
                "10": {
                    value: "#102000",
                    type: "color",
                },
                "20": {
                    value: "#1e3700",
                    type: "color",
                },
                "25": {
                    value: "#264300",
                    type: "color",
                },
                "30": {
                    value: "#2e4f00",
                    type: "color",
                },
                "35": {
                    value: "#375c00",
                    type: "color",
                },
                "40": {
                    value: "#3f6900",
                    type: "color",
                },
                "50": {
                    value: "#518500",
                    type: "color",
                },
                "60": {
                    value: "#63a100",
                    type: "color",
                },
                "70": {
                    value: "#76be00",
                    type: "color",
                },
                "80": {
                    value: "#89dc00",
                    type: "color",
                },
                "90": {
                    value: "#8ee400",
                    type: "color",
                },
                "95": {
                    value: "#d2ff9c",
                    type: "color",
                },
                "98": {
                    value: "#f0ffd7",
                    type: "color",
                },
                "99": {
                    value: "#f9ffe9",
                    type: "color",
                },
                "100": {
                    value: "#ffffff",
                    type: "color",
                },
            },
            blue: {
                "0": {
                    value: "#000000",
                    type: "color",
                },
                "10": {
                    value: "#001f26",
                    type: "color",
                },
                "20": {
                    value: "#00363f",
                    type: "color",
                },
                "25": {
                    value: "#00424d",
                    type: "color",
                },
                "30": {
                    value: "#004e5b",
                    type: "color",
                },
                "35": {
                    value: "#005b6a",
                    type: "color",
                },
                "40": {
                    value: "#006879",
                    type: "color",
                },
                "50": {
                    value: "#008397",
                    type: "color",
                },
                "60": {
                    value: "#009fb7",
                    type: "color",
                },
                "70": {
                    value: "#00bcd8",
                    type: "color",
                },
                "80": {
                    value: "#1dd9f9",
                    type: "color",
                },
                "90": {
                    value: "#a8edff",
                    type: "color",
                },
                "95": {
                    value: "#d7f6ff",
                    type: "color",
                },
                "98": {
                    value: "#f0fbff",
                    type: "color",
                },
                "99": {
                    value: "#f8fdff",
                    type: "color",
                },
                "100": {
                    value: "#ffffff",
                    type: "color",
                },
            },
            yellow: {
                "0": {
                    value: "#000000",
                    type: "color",
                },
                "10": {
                    value: "#201c00",
                    type: "color",
                },
                "20": {
                    value: "#373100",
                    type: "color",
                },
                "25": {
                    value: "#443c00",
                    type: "color",
                },
                "30": {
                    value: "#504700",
                    type: "color",
                },
                "35": {
                    value: "#5d5300",
                    type: "color",
                },
                "40": {
                    value: "#6a5f00",
                    type: "color",
                },
                "50": {
                    value: "#867800",
                    type: "color",
                },
                "60": {
                    value: "#a29100",
                    type: "color",
                },
                "70": {
                    value: "#c0ac00",
                    type: "color",
                },
                "80": {
                    value: "#dec800",
                    type: "color",
                },
                "90": {
                    value: "#fee400",
                    type: "color",
                },
                "95": {
                    value: "#fff2aa",
                    type: "color",
                },
                "98": {
                    value: "#fff9ea",
                    type: "color",
                },
                "99": {
                    value: "#fffbff",
                    type: "color",
                },
                "100": {
                    value: "#ffffff",
                    type: "color",
                },
            },
            purple: {
                "0": {
                    value: "#000000",
                    type: "color",
                },
                "10": {
                    value: "#310048",
                    type: "color",
                },
                "20": {
                    value: "#510073",
                    type: "color",
                },
                "25": {
                    value: "#62008a",
                    type: "color",
                },
                "30": {
                    value: "#7300a1",
                    type: "color",
                },
                "35": {
                    value: "#8215b2",
                    type: "color",
                },
                "40": {
                    value: "#9029bf",
                    type: "color",
                },
                "50": {
                    value: "#ab48da",
                    type: "color",
                },
                "60": {
                    value: "#c864f7",
                    type: "color",
                },
                "70": {
                    value: "#db8bff",
                    type: "color",
                },
                "80": {
                    value: "#eab2ff",
                    type: "color",
                },
                "90": {
                    value: "#f7d8ff",
                    type: "color",
                },
                "95": {
                    value: "#fdebff",
                    type: "color",
                },
                "98": {
                    value: "#fff7fb",
                    type: "color",
                },
                "99": {
                    value: "#fffbff",
                    type: "color",
                },
                "100": {
                    value: "#ffffff",
                    type: "color",
                },
            },
            red: {
                "0": {
                    value: "#000000",
                    type: "color",
                },
                "10": {
                    value: "#410004",
                    type: "color",
                },
                "20": {
                    value: "#68000a",
                    type: "color",
                },
                "25": {
                    value: "#7d000e",
                    type: "color",
                },
                "30": {
                    value: "#930012",
                    type: "color",
                },
                "35": {
                    value: "#a90016",
                    type: "color",
                },
                "40": {
                    value: "#be0c1e",
                    type: "color",
                },
                "50": {
                    value: "#e22e33",
                    type: "color",
                },
                "60": {
                    value: "#ff5450",
                    type: "color",
                },
                "70": {
                    value: "#ff8981",
                    type: "color",
                },
                "80": {
                    value: "#ffb3ad",
                    type: "color",
                },
                "90": {
                    value: "#ffdad7",
                    type: "color",
                },
                "95": {
                    value: "#ffedeb",
                    type: "color",
                },
                "98": {
                    value: "#fff8f7",
                    type: "color",
                },
                "99": {
                    value: "#fffbff",
                    type: "color",
                },
                "100": {
                    value: "#ffffff",
                    type: "color",
                },
            },
        },
        shadow: {
            medium: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "20px",
                            spread: "0px",
                            color: "#161B2B1F",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "2px",
                            spread: "0px",
                            color: "#0000001A",
                        },
                    ],
                    stringValue: "0px 6px 20px 0px #161B2B1F, 0px 0px 2px 0px #0000001A",
                },
                type: "shadow",
            },
            high: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "10px",
                            blur: "24px",
                            spread: "0px",
                            color: "#161B2B29",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "2px",
                            spread: "0px",
                            color: "#161B2B1A",
                        },
                    ],
                    stringValue: "0px 10px 24px 0px #161B2B29, 0px 0px 2px 0px #161B2B1A",
                },
                type: "shadow",
            },
        },
        spacing: {
            "0": {
                value: "0px",
                type: "dimension",
            },
            "1": {
                value: "8px",
                type: "dimension",
            },
            "2": {
                value: "16px",
                type: "dimension",
            },
            "3": {
                value: "24px",
                type: "dimension",
            },
            "4": {
                value: "32px",
                type: "dimension",
            },
            "5": {
                value: "40px",
                type: "dimension",
            },
            "6": {
                value: "48px",
                type: "dimension",
            },
            "7": {
                value: "56px",
                type: "dimension",
            },
            px: {
                value: "1px",
                type: "dimension",
            },
            "0_25": {
                value: "2px",
                type: "dimension",
            },
            "0_5": {
                value: "4px",
                type: "dimension",
            },
            "1_5": {
                value: "12px",
                type: "dimension",
            },
            "2_5": {
                value: "20px",
                type: "dimension",
            },
        },
        breakpoints: {
            mobile: {
                min: {
                    value: "0px",
                    type: "dimension",
                },
                max: {
                    value: "600px",
                    type: "dimension",
                },
            },
            tablet: {
                min: {
                    value: "601px",
                    type: "dimension",
                },
                max: {
                    value: "1279px",
                    type: "dimension",
                },
            },
            desktop: {
                min: {
                    value: "1280px",
                    type: "dimension",
                },
            },
        },
        fontFamily: {
            plusJakartaSans: {
                value: "Plus Jakarta Sans Variable",
            },
        },
        textDecoration: {
            none: {
                value: "none",
                type: "string",
            },
            underline: {
                value: "underline",
                type: "string",
            },
        },
        fontWeight: {
            extraLight: {
                value: 200,
                type: "number",
            },
            light: {
                value: 300,
                type: "number",
            },
            regular: {
                value: 400,
                type: "number",
            },
            medium: {
                value: 500,
                type: "number",
            },
            semiBold: {
                value: 600,
                type: "number",
            },
            bold: {
                value: 700,
                type: "number",
            },
            extraBold: {
                value: 800,
                type: "number",
            },
        },
        textTransform: {
            none: {
                value: "none",
                type: "string",
            },
            uppercase: {
                value: "uppercase",
                type: "string",
            },
            lowercase: {
                value: "lowercase",
                type: "string",
            },
            capitalize: {
                value: "capitalize",
                type: "string",
            },
        },
    },
};
export default tokens;
